class Form {
  theme = null;

  constructor(theme) {
    this.theme = theme;
    Form.instance = this;
  }

  static init(theme) {
    Form.instance = null;
    return new Form(theme);
  }

  getRowStyle() {
    return {
      display: "flex",
      alignItems: "center",
      gap: 2,
    };
  }

  getLabelStyle() {
    return {
      width: "150px",
      color: this.theme.palette.primary.main,
      fontSize: this.theme.typography.customFontSize[2],
      fontWeight: this.theme.typography.customFontWeight[1],
    };
  }

  getTextfieldStyle = (isValid = true) => ({
    width: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: '8px',
      height: "36px",
      backgroundColor: this.theme.palette.primary.white,

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.borderGreyPrimary
          : this.theme.palette.primary.redPrimary,
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.mainHover
          : this.theme.palette.primary.redPrimary,
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.main
          : this.theme.palette.primary.redPrimary,
      },
    },
  });

  getBannerStyle() {
    return {
      mx: 0,
      my: 2,
      p: 1.5,
      bgcolor: 'rgba(21, 67, 137, 0.05)',
      borderLeft: `3px solid ${this.theme.palette.primary.main}`,
      borderRadius: '4px',
      color: this.theme.palette.primary.main,
    };
  }

  getNumberStyle(deleteAction = true) {
    return {
      minWidth: '24px',
      height: '20px',
      fontSize: '12px',
      fontWeight: 500,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: deleteAction ? this.theme.palette.primary.main : this.theme.palette.primary.white,
      color: deleteAction ? this.theme.palette.primary.white : this.theme.palette.primary.main,
      borderRadius: '15px',
      padding: '0 15px',
      marginLeft: '4px',
    };
  }

  getTableStyle() {
    return {
      marginTop: "10px",
      padding: "10px",
    };
  }
}

Form.prototype.getMaskStyle = function () {
  return {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 10,
    backgroundColor: this.theme.palette.primary.greyPrimary,
    opacity: 0.2,
    borderRadius: 8,
  };
}

Form.prototype.getInnerViewStyle = function (zIndex) {
  return {
    position: "absolute",
    top: 0,
    left: 0,
    display: "flex",
    width: "100%",
    height: "auto",
    backgroundColor: this.theme.palette.primary.white,
    boxShadow: this.theme.shadows[5],
    borderRadius: this.theme.shape.customBorderRadius[2],
    zIndex: zIndex.modal + 2,
  };
}

Form.prototype.getInnerContainerStyle = function () {
  return {
    padding: "20px",
    width: "100%",
  }
}

export default Form;
